import Swiper from "swiper";
import { Navigation, Pagination, EffectFade } from "swiper/modules";

new Swiper(".process__slider", {
    modules: [Navigation, Pagination, EffectFade],
    slidesPerView: 1,
    effect: "fade",
    pagination: {
        el: ".process__pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: ".process__next",
        prevEl: ".process__prev",
    },
});
